import PlainTextCell from 'components/PlainTextCell';

type Props = {
  rowData: Pick<SentinelTeam, 'platformAccounts' | 'scheduledForDeletionAt'>;
};

export default function PlatformAccountsCell({
  rowData: { platformAccounts, scheduledForDeletionAt },
}: Props) {
  return (
    <PlainTextCell
      color={scheduledForDeletionAt ? 'alaskanHusky' : undefined}
      topLine={platformAccounts
        ?.map(({ sourceId }) => sourceId)
        .sort()
        .join(', ')}
    />
  );
}
